import { convertUTCToLocal } from "@/utility/dateHelper";

export const GetFormattedBulkPointModifiers = (apiResponse = {}) => {
    const {
        data,
        totalRecords = '',
        totalPages = '',
        pageSize = '',
        currentPage = '',
        activeCount = '',

    } = apiResponse;

    const formattedBulkModifiers = data?.map(GetBulkPointModifier);

    return {
        data: formattedBulkModifiers,
        totalRecords,
        totalPages,
        pageSize,
        currentPage,
        activeCount,
    };
};

// Helper function to map individual items
const GetBulkPointModifier = (item = {}) => {
    const {
        id = null,
        bulkModifierName = "",
        noOfStores = 0,
        createdAt,
        application = null,
        importFile = null,
        scheduledAt,
        type = "",
        status = "",
        uuid = ""
    } = item;

    return {
        id,
        bulkModifierName,
        noOfStores,
        createdAt: convertUTCToLocal(createdAt),
        application,
        importFile,
        scheduledAt: convertUTCToLocal(scheduledAt),
        type,
        status,
        uuid
    };
};
